const projects = [
    {
        id: 'marketing-microsites',
        img: 4,
        titleKey: 'pjTtl1',
        descriptionKey: 'pjDes1',
        tools: ['HTML5', 'Sass', 'JavaScript', 'Hubspot', 'MySql', 'PHP'],
        link: 'https://client-qa-zone.web.app/n33tflix.html',
        datasets: ['dev', 'ops'],
    },
    {
        id: 'ecommerce-development',
        img: 2,
        titleKey: 'pjTtl2',
        descriptionKey: 'pjDes2',
        tools: ['Shopify', 'Sass', 'CMS', 'MySql', 'PHP', 'JavaScript'],
        link: 'internal:ecommerce',
        datasets: ['dev', 'ops'],
    },
    {
        id: 'ferrovial-newsroom',
        img: 12,
        titleKey: 'pjTtl10',
        descriptionKey: 'pjDes10',
        tools: ['PHP', 'HTML5', 'Sass', 'MySql', 'CSS'],
        link: 'https://newsroom.ferrovial.com/en-us/',
        datasets: ['dev', 'ops'],
    },
    {
        id: 'radio-mexiquense-app',
        img: 5,
        titleKey: 'pjTtl3',
        descriptionKey: 'pjDes3',
        tools: ['Ionic', 'Angular', 'CSS3', 'SpringBoot', 'MySql', 'API REST'],
        link: 'https://x.com/mexiquensetv/status/1349366750815670280',
        datasets: ['dev'],
    },
    {
        id: 'travel-platform',
        img: 11,
        titleKey: 'pjTtl8',
        descriptionKey: 'pjDes8',
        tools: ['HTML5', 'Sass', 'JavaScript', 'Hubspot', 'MySql', 'PHP'],
        link: 'https://my-travel-ea3f1.web.app/',
        datasets: ['dev', 'data'],
    },
    {
        id: 'mapfre-quotation',
        img: 1,
        titleKey: 'pjTtl9',
        descriptionKey: 'pjDes9',
        tools: ['Angular', 'HTML5', 'Sass', 'Node', 'MySql', 'Bootstrap'],
        link: 'https://cotizadorautos.mapfre.com.mx/',
        datasets: ['dev', 'data'],
    },
    {
        id: 'email-marketing',
        img: 6,
        titleKey: 'pjTtl6',
        descriptionKey: 'pjDes6',
        tools: ['HTML5', 'CSS', 'Mailchimp'],
        link: '#',
        datasets: ['dev', 'ops'],
    },

    {
        id: 'claims-platform',
        img: 9,
        titleKey: 'pjTtl4',
        descriptionKey: 'pjDes4',
        tools: ['Angular', 'HTML5', 'Sass', 'Angular Material UI'],
        link: 'https://cardif.com.mx/siniestro',
        datasets: ['dev', 'data'],
    },
    {
        id: 'enterprise-systems',
        img: 8,
        titleKey: 'pjTtl5',
        descriptionKey: 'pjDes5',
        tools: ['React', 'HTML5', 'Sass', 'Node', 'Bootstrap'],
        link: 'https://www.linkedin.com/posts/pleed-tech_gestiaejnfinanciera-sistemafinanciero-fms-activity-6914257396357869568-AIzd?utm_source=share&utm_medium=member_desktop&rcm=ACoAACjVbygBeD2JfQrbV7QyLxaiMRD9rZtYcbQ',
        datasets: ['dev', 'data'],
    },




];

export function getProjectsByDataset(datasetId) {
    return projects.filter((project) => project.datasets.includes(datasetId));
}

export { projects };


// {
//         id: 'recruitment-platform',
//         img: 7,
//         titleKey: 'pjTtl7',
//         descriptionKey: 'pjDes7',
//         tools: ['React', 'Sass', 'Hubspot', 'PHP', 'API REST'],
//         link: 'https://www.ubbittnetwork.com/',
//         datasets: ['dev', 'data'],
//     },
